<template>
  <div class="gx-staff">
    <div class="gx-staff__filter custom-form-wrap">
      <el-form inline size="mini">
        <el-form-item>
          <el-input v-model="searchData.mobile" clearable placeholder="员工手机号" @keyup.enter="getList(true)" />
        </el-form-item>
        <el-form-item>
          <button type="button" class="gx-staff__btn gx-staff__btn--primary" @click="getList(true)">查询</button>
          <button type="button" class="gx-staff__btn" @click="resetSearch" style="margin-left: 5px">重置</button>
        </el-form-item>
      </el-form>
     <div class="gx-staff__head">
      <!-- <h1 class="gx-main__title">员工管理</h1> -->
      <button class="gx-staff__add" @click="employeeOpen(null)">
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M5.5 1v9M1 5.5h9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" /></svg>
        新增员工
      </button>
    </div>
    </div>

    <div class="gx-staff__card">
      <div class="gx-staff__table">
        <table>
          <thead>
            <tr>
              <th v-for="h in ['员工姓名', '员工手机号', '员工岗位', '创建时间', '状态', '操作']" :key="h">{{ h }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="emp in list" :key="emp.mer_user_sub_id">
              <td>
                <div class="gx-staff__name-cell">
                  <span class="gx-staff__avatar">{{ (emp.nickname || '员')[0] }}</span>
                  <div>
                    <div class="gx-staff__name">{{ emp.nickname }}</div>
                    <div class="gx-staff__sub">子账户</div>
                  </div>
                </div>
              </td>
              <td class="gx-staff__mono">{{ maskPhone(emp.mobile) }}</td>
              <td>
                <span class="gx-staff__role-tag">{{ (emp.user_role && emp.user_role.name) || '未配置' }}</span>
              </td>
              <td class="gx-staff__mono gx-staff__dim">{{ emp.created_at }}</td>
              <td>
                <span class="gx-staff__status" :class="emp.status == 1 ? 'gx-staff__status--on' : 'gx-staff__status--off'">
                  <span class="gx-staff__status-dot"></span>{{ emp.status_name || (emp.status == 1 ? '正常' : '禁用') }}
                </span>
              </td>
              <td>
                <div class="gx-staff__ops">
                  <button class="gx-staff__op gx-staff__op--edit" @click="employeeOpen(emp)">编辑</button>
                  <button class="gx-staff__op gx-staff__op--del" @click="employeeDel(emp)">删除</button>
                </div>
              </td>
            </tr>
            <tr v-if="!list.length">
              <td :colspan="6" class="gx-staff__empty">
                <div class="gx-staff__empty-box">
                  <div class="gx-staff__empty-icon">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                      <circle cx="14" cy="10" r="4.5" stroke="#C8443C" stroke-width="1.6" />
                      <path d="M6.5 22.5c1.8-3.6 4.4-5.4 7.5-5.4s5.7 1.8 7.5 5.4" stroke="#C8443C" stroke-width="1.6" stroke-linecap="round" />
                    </svg>
                  </div>
                  <div class="gx-staff__empty-title">暂无员工数据</div>
                  <div class="gx-staff__empty-sub">点击下方按钮添加第一个员工,员工将以手机号方式登录系统</div>
                  <button class="gx-staff__add" @click="employeeOpen(null)">
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M5.5 1v9M1 5.5h9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" /></svg>
                    新增员工
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <div class="gx-staff__pager">
        <div class="gx-staff__pager-left">
          <span class="gx-staff__pager-total">共 {{ pageData.total }} 条 </span>
          <page-size-select :value="pageData.limit" :options="pageSizeOptions" @change="onPageSizeChange" />
        </div>
        <div class="gx-staff__pager-btns">
          <button class="gx-staff__page" :disabled="pageData.page <= 1" @click="getList(true, pageData.page - 1)">上一页</button>
          <button v-for="n in pageNums" :key="n" class="gx-staff__page" :class="{ 'gx-staff__page--on': n === pageData.page }" @click="getList(true, n)">{{ n }}</button>
          <button class="gx-staff__page" :disabled="pageData.page >= totalPages" @click="getList(true, pageData.page + 1)">下一页</button>
        </div>
      </div> -->
      <div style="padding: 10px 14px;background: rgb(245, 240, 232);">
        <Pagination :total="pageData.total" :page.sync="pageData.page" :limit.sync="pageData.limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getList(true,pageData.page)"  layout="total, sizes, prev, pager, next, jumper" />
      </div>
    </div>

    <!-- 新增/编辑员工弹窗 -->
    <div v-if="editShow" class="gx-staff__modal" @click.self="editShow = false">
      <div class="gx-staff__modal-box">
        <div class="gx-staff__modal-head">
          <div class="gx-staff__modal-title-wrap">
            <span class="gx-staff__modal-bar"></span>
            <span class="gx-staff__modal-title">{{ editInfo.mer_user_sub_id ? '修改员工' : '新增员工' }}</span>
          </div>
          <button class="gx-staff__modal-close" @click="editShow = false">
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M1 1l9 9M10 1L1 10" stroke="#4A4A6A" stroke-width="1.4" stroke-linecap="round" /></svg>
          </button>
        </div>
        <div class="gx-staff__modal-body">
          <div class="gx-staff__field">
            <label class="gx-staff__field-label"><span class="gx-staff__req">*</span>员工名称</label>
            <input v-model="editInfo.nickname" class="gx-staff__field-input" placeholder="请输入员工名称" />
          </div>
          <div class="gx-staff__field">
            <label class="gx-staff__field-label"><span class="gx-staff__req">*</span>员工手机号</label>
            <div class="gx-staff__phone-wrap">
              <span class="gx-staff__phone-prefix">+86</span>
              <input v-model="editInfo.mobile" class="gx-staff__field-input gx-staff__phone-input" placeholder="请输入员工手机号" type="tel" maxlength="11" />
            </div>
            <div class="gx-staff__phone-count">{{ (editInfo.mobile || '').length }} / 11</div>
          </div>
          <div class="gx-staff__field">
            <label class="gx-staff__field-label"><span class="gx-staff__req">*</span>密码</label>
            <div class="gx-staff__pw-wrap">
              <input v-model="editInfo.password" class="gx-staff__field-input gx-staff__pw-input" :type="showPw ? 'text' : 'password'" placeholder="请输入密码" />
              <button type="button" class="gx-staff__pw-eye" @click="showPw = !showPw">
                <svg v-if="showPw" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M1 7.5C2.5 5 5 3 7.5 3s5 2 6.5 4.5C12.5 10 10 12 7.5 12S2.5 10 1 7.5z" stroke="currentColor" stroke-width="1.2" /><circle cx="7.5" cy="7.5" r="2" stroke="currentColor" stroke-width="1.2" /></svg>
                <svg v-else width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M1 7.5C2.5 5 5 3 7.5 3s5 2 6.5 4.5C12.5 10 10 12 7.5 12S2.5 10 1 7.5z" stroke="currentColor" stroke-width="1.2" /><path d="M2 2l11 11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" /></svg>
              </button>
            </div>
          </div>
          <div class="gx-staff__field">
            <label class="gx-staff__field-label"><span class="gx-staff__req">*</span>岗位类型</label>
            <select v-model="editInfo.role_id" class="gx-staff__select">
              <option :value="null" disabled>请选择岗位</option>
              <option v-for="r in roleList" :key="r.val" :value="r.val">{{ r.key }}</option>
            </select>
            <div class="gx-staff__field-tip">员工将获得所选岗位的对应菜单权限</div>
          </div>
          <div class="gx-staff__field" v-if="editInfo.mer_user_sub_id">
            <label class="gx-staff__field-label">状态</label>
            <div class="gx-staff__status-group">
              <div
                class="gx-staff__status-item"
                :class="{ 'is-active': editInfo.status == '1' || editInfo.status == 1 }"
                @click="editInfo.status = '1'"
              >
                <span class="gx-staff__status-radio"></span>
                <span>启用</span>
              </div>
              <div
                class="gx-staff__status-item"
                :class="{ 'is-active': editInfo.status == '2' || editInfo.status == 2 }"
                @click="editInfo.status = '2'"
              >
                <span class="gx-staff__status-radio"></span>
                <span>禁用</span>
              </div>
            </div>
          </div>
        </div>
        <div class="gx-staff__modal-foot">
          <button class="gx-staff__modal-btn" @click="editShow = false">取消</button>
          <button class="gx-staff__modal-btn gx-staff__modal-btn--primary" :disabled="saving" @click="saveEdit">
            {{ saving ? '保存中...' : '保存' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PageSizeSelect from '../../components/newUi/PageSizeSelect.vue'
import Pagination from '../../components/newUi/Pagination.vue'

export default {
  name: 'NewStaffPage',
  components: { PageSizeSelect,Pagination },
  data() {
    return {
      searchData: {},
      pageData: { limit: 100, page: 1, total: 0 },
      pageSizeOptions: [10, 20, 50, 100, 200],
      list: [],
      roleList: [],
      editShow: false,
      editInfo: {},
      saving: false,
      showPw: false
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.pageData.total / this.pageData.limit))
    },
    pageNums() {
      const total = this.totalPages
      const nums = []
      const start = Math.max(1, Math.min(this.pageData.page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    }
  },
  created() {
    this.getRoleList()
    this.getList(true)
  },
  methods: {
    ...mapActions({
      getAgentuserIndex: 'ucenter/getAgentuserIndex',
      getAgentuserFieldList: 'ucenter/getAgentuserFieldList',
      opAgentuserAdd: 'ucenter/opAgentuserAdd',
      opAgentuserUpdate: 'ucenter/opAgentuserUpdate',
      opAgentuserDel: 'ucenter/opAgentuserDel',
      opAgentuserExt: 'ucenter/opAgentuserExt'
    }),
    onPageSizeChange(size) {
      this.pageData.limit = size
      this.pageData.page = 1
      this.getList(true, 1)
    },
    getList(showLoading, page) {
      if (page) this.pageData.page = page
      const param = { page_size: this.pageData.limit, page: this.pageData.page }
      Object.assign(param, this.searchData)
      if(param?.mobile?.trim()==='') delete param.mobile
      this.getAgentuserIndex({
        data: param,
        success: (res) => {
          if (res.code === 200) {
            this.list = res.data.list
            this.pageData.total = res.data.total
          } else {
            this.$message({ message: res.message, type: 'error' })
          }
        }
      })
    },
    getRoleList() {
      this.getAgentuserFieldList({
        data: { status: 1, page_size: 100 },
        success: (res) => {
          if (res.code === 200) {
            this.roleList = []
            if (res.data.list) {
              res.data.list.forEach((item) => {
                this.roleList.push({ key: item.name, val: item.role_id })
              })
            }
          }
        }
      })
    },
    resetSearch() {
      this.searchData = {}
      this.pageData.page = 1
      this.getList(true)
    },
    employeeOpen(row) {
      this.editShow = true
      this.showPw = false
      if (row) {
        this.editInfo = Object.assign({}, row)
        if (row.sub_role_id != 0) this.editInfo.role_id = Number(row.sub_role_id)
        delete this.editInfo.password
      } else {
        this.editInfo = { nickname: '', mobile: '', password: '', role_id: null }
      }
    },
    employeeDel(row) {
      this.$confirm('确定删除该员工吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opAgentuserDel({
          data: { mer_user_sub_id: row.mer_user_sub_id },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.message)
              this.getList(true)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },
    employeeStatus(row) {
      const param = { id: row.id, status: row.status }
      this.opAgentuserExt({
        data: param,
        success: (res) => {
          if (res.code === 200) {
            this.$message.success(res.message)
            this.getList(true)
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    maskPhone(phone) {
      if (!phone || phone.length < 7) return phone || '-'
      return phone.substr(0, 3) + '****' + phone.substr(7)
    },
    saveEdit() {
      if (!this.editInfo.nickname) {
        this.$message.info('请输入员工名称！')
        return
      }
      if (!this.editInfo.mobile) {
        this.$message.info('请输入员工手机号！')
        return
      }
      if (!this.editInfo.role_id) {
        this.$message.info('请选择岗位！')
        return
      }
      this.saving = true
      const param = Object.assign({}, this.editInfo)
      if (!param.mer_user_sub_id) {
        if (!param.password) {
          this.saving = false
          this.$message.info('请输入密码！')
          return
        }
        this.opAgentuserAdd({
          data: param,
          success: (res) => {
            this.saving = false
            if (res.code === 200) {
              this.$message.success(res.message)
              this.editShow = false
              this.pageData.page = 1
              this.getList(true)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      } else {
        this.opAgentuserUpdate({
          data: param,
          success: (res) => {
            this.saving = false
            if (res.code === 200) {
              this.$message.success(res.message)
              this.editShow = false
              this.getList(true)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.gx-staff__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* margin-bottom: 16px; */
}
.gx-staff__add {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 32px;
  padding: 0 14px;
  border-radius: 7px;
  cursor: pointer;
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  box-shadow: 0 2px 8px rgba(212, 169, 70, .28);
  transition: opacity .16s;
}
.gx-staff__add:hover {
  opacity: .92;
}
.gx-staff__filter {
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 16px;
  background: #FFFFFF;
  border: 1px solid #E1E5EE;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
}
.gx-staff__input {
  width: 180px;
  height: 32px;
  padding: 0 10px;
  border-radius: 7px;
  border: 1px solid #E0E0EC;
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
  transition: border .15s;
}
.gx-staff__input:focus {
  border-color: rgba(212, 169, 70, .65);
  box-shadow: 0 0 0 2px rgba(212, 169, 70, .12);
}
.gx-staff__btn {
  height: 32px;
  padding: 0 14px;
  border-radius: 7px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid #E0E0EC;
  font-size: 13px;
  color: #4A4A6A;
  transition: all .16s;
}
.gx-staff__btn:hover:not(:disabled) {
  border-color: rgba(212, 169, 70, .5);
  color: #D4A946;
}
.gx-staff__btn--primary {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  font-weight: 600;
  color: #fff;
}
.gx-staff__btn--primary:hover:not(:disabled) {
  color: #fff;
  opacity: .92;
}
.gx-staff__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-staff__card {
  border-radius: 12px;
  border: 1px solid #E1E5EE;
  margin-bottom: 16px;
  background: #FFFFFF;
  overflow: visible;
}
.gx-staff__table {
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  background: #FFFFFF;
}
.gx-staff__table table {
  width: 100%;
  border-collapse: collapse;
}
.gx-staff__table th {
  padding: 11px 14px;
  text-align: left;
  background: #F5F0E8;
  font-size: 12px;
  font-weight: 500;
  color: #4A4A6A;
  letter-spacing: .02em;
}
.gx-staff__table td {
  padding: 12px 14px;
  font-size: 13px;
  color: #1A1A2E;
  border-top: 1px solid #F0F0F4;
}
.gx-staff__name-cell {
  display: flex;
  align-items: center;
  gap: 9px;
}
.gx-staff__avatar {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(135deg, #D4A946, #E8B950);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Noto Serif SC', serif;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  flex-shrink: 0;
}
.gx-staff__name {
  font-size: 13px;
  font-weight: 500;
  color: #1A1A2E;
}
.gx-staff__sub {
  font-size: 10px;
  color: #6A6A8A;
  margin-top: 1px;
}
.gx-staff__mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
}
.gx-staff__dim {
  color: #6A6A8A;
}
.gx-staff__role-tag {
  padding: 3px 10px;
  border-radius: 5px;
  background: #E6F4FF;
  border: 1px solid #91CAFF;
  font-size: 11px;
  font-weight: 500;
  color: #1677FF;
}
.gx-staff__status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
}
.gx-staff__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
.gx-staff__status--on {
  color: #16A34A;
}
.gx-staff__status--on .gx-staff__status-dot {
  background: #22C55E;
}
.gx-staff__status--off {
  color: #6A6A8A;
}
.gx-staff__status--off .gx-staff__status-dot {
  background: #6A6A8A;
}
.gx-staff__ops {
  display: flex;
  gap: 6px;
}
.gx-staff__op {
  height: 26px;
  padding: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 11px;
  border: 1px solid;
  transition: all .16s;
}
.gx-staff__op--edit {
  background: #E6F4FF;
  border-color: #91CAFF;
  color: #1677FF;
}
.gx-staff__op--edit:hover {
  background: #1677FF;
  color: #fff;
}
.gx-staff__op--del {
  background: #FFF5F5;
  border-color: #FFCCC7;
  color: #C8443C;
}
.gx-staff__op--del:hover {
  background: #C8443C;
  color: #fff;
}
.gx-staff__empty {
  text-align: center;
  padding: 48px 0 !important;
}
.gx-staff__empty-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.gx-staff__empty-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #FFF5F5;
  border: 1px solid #FFCCC7;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}
.gx-staff__empty-title {
  font-size: 14px;
  font-weight: 500;
  color: #1A1A2E;
  margin-bottom: 6px;
}
.gx-staff__empty-sub {
  font-size: 12px;
  color: #6A6A8A;
  line-height: 1.7;
  margin-bottom: 16px;
  max-width: 400px;
}
.gx-staff__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 14px;
  border-top: 1px solid #E0E0EC;
  background: #F5F0E8;
  border-radius: 0 0 12px 12px;
  position: relative;
  z-index: 5;
}
.gx-staff__pager-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.gx-staff__pager-total {
  font-size: 12px;
  color: #6A6A8A;
}
.gx-staff__pager-btns {
  display: flex;
  gap: 5px;
}
.gx-staff__page {
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: #4A4A6A;
}
.gx-staff__page:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-staff__page--on {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  color: #fff;
  font-weight: 700;
}
.gx-staff__modal {
  position: fixed;
  inset: 0;
  z-index: 700;
  background: rgba(8, 14, 36, .55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-staff__modal-box {
  width: 100%;
  max-width: 460px;
  border-radius: 12px;
  background: #FFFFFF;
  border: 1px solid #E0E0EC;
  box-shadow: 0 12px 48px rgba(0, 0, 0, .18);
  overflow: hidden;
}
.gx-staff__modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 20px;
  border-bottom: 1px solid #E0E0EC;
  background: #F5F0E8;
}
.gx-staff__modal-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gx-staff__modal-bar {
  width: 3px;
  height: 15px;
  border-radius: 2px;
  background: #C8443C;
}
.gx-staff__modal-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-staff__modal-close {
  width: 26px;
  height: 26px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #E0E0EC;
  cursor: pointer;
  padding: 0;
}
.gx-staff__modal-close:hover {
  background: #FFF5F5;
}
.gx-staff__modal-body {
  padding: 20px 20px 8px;
  background: #fff;
}
.gx-staff__field {
  margin-bottom: 16px;
}
.gx-staff__field-label {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #4A4A6A;
}
.gx-staff__req {
  color: #C8443C;
  font-size: 13px;
}
.gx-staff__field-input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border-radius: 6px;
  border: 1px solid #E0E0EC;
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
  transition: border .15s;
  background: #fff;
}
.gx-staff__field-input:focus {
  border-color: rgba(212, 169, 70, .65);
  box-shadow: 0 0 0 2px rgba(212, 169, 70, .12);
}
.gx-staff__phone-wrap {
  display: flex;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #E0E0EC;
  overflow: hidden;
  transition: border .15s;
}
.gx-staff__phone-wrap:focus-within {
  border-color: rgba(212, 169, 70, .65);
  box-shadow: 0 0 0 2px rgba(212, 169, 70, .12);
}
.gx-staff__phone-prefix {
  display: flex;
  align-items: center;
  padding: 0 10px;
  background: #F5F0E8;
  border-right: 1px solid #E0E0EC;
  font-size: 12px;
  color: #4A4A6A;
  flex-shrink: 0;
}
.gx-staff__phone-input {
  border: none;
  border-radius: 0;
  box-shadow: none !important;
  font-family: 'JetBrains Mono', monospace;
  font-size: 14px;
  letter-spacing: .04em;
}
.gx-staff__phone-count {
  margin-top: 4px;
  font-size: 11px;
  color: #6A6A8A;
  font-family: 'JetBrains Mono', monospace;
}
.gx-staff__pw-wrap {
  position: relative;
}
.gx-staff__pw-input {
  padding-right: 36px;
}
.gx-staff__pw-eye {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #6A6A8A;
  line-height: 0;
  padding: 0;
}
.gx-staff__pw-eye:hover {
  color: #D4A946;
}
.gx-staff__select {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border-radius: 6px;
  border: 1px solid #E0E0EC;
  background: #FFFFFF;
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
}
.gx-staff__select:focus {
  border-color: rgba(212, 169, 70, .65);
  box-shadow: 0 0 0 2px rgba(212, 169, 70, .12);
}
.gx-staff__field-tip {
  font-size: 11px;
  color: #6A6A8A;
  margin-top: 6px;
  line-height: 1.5;
}
.gx-staff__status-group {
  display: flex;
  gap: 10px;
}
.gx-staff__status-item {
  flex: 1;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid #E0E0EC;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  color: #6A6A8A;
  transition: all .15s;
  background: #fff;
  user-select: none;
}
.gx-staff__status-item:hover {
  border-color: rgba(212, 169, 70, .4);
}
.gx-staff__status-item.is-active {
  border-color: #D4A946;
  background: rgba(212, 169, 70, .08);
  color: #1A1A2E;
  font-weight: 500;
}
.gx-staff__status-radio {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1.5px solid #D0D0DD;
  position: relative;
  flex-shrink: 0;
  transition: all .15s;
}
.gx-staff__status-item.is-active .gx-staff__status-radio {
  border-color: #D4A946;
}
.gx-staff__status-item.is-active .gx-staff__status-radio::after {
  content: '';
  position: absolute;
  inset: 2px;
  border-radius: 50%;
  background: #D4A946;
}
.gx-staff__modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #E0E0EC;
  background: #F5F0E8;
}
.gx-staff__modal-btn {
  height: 32px;
  padding: 0 16px;
  border-radius: 5px;
  cursor: pointer;
  background: #fff;
  border: 1px solid #E0E0EC;
  font-size: 13px;
  color: #4A4A6A;
  transition: all .15s;
}
.gx-staff__modal-btn:hover:not(:disabled) {
  border-color: rgba(212, 169, 70, .5);
  color: #D4A946;
}
.gx-staff__modal-btn--primary {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  font-weight: 600;
  color: #fff;
}
.gx-staff__modal-btn--primary:hover:not(:disabled) {
  color: #fff;
  opacity: .92;
}
.gx-staff__modal-btn--primary:disabled {
  background: #f0f0f0;
  color: #6A6A8A;
  opacity: .6;
  cursor: not-allowed;
}
</style>
